<app-game-connect></app-game-connect>
<app-ethereum-connect></app-ethereum-connect>